import React, { CSSProperties, ChangeEvent, FocusEvent, ReactNode, useState } from "react";

import { Input as AntInput } from "antd";
import { Rule } from "antd/es/form";
import { NamePath } from "antd/es/form/interface";

import { parseInputRules } from "utils";

import { Form } from "components";

export type InputWithAddonAfterProps = {
  addonAfter: string | ReactNode;
  dataTestId?: string;
  disabled?: boolean;
  initialValue?: string | number | undefined;
  message?: string;
  name?: NamePath;
  placeholder?: string;
  rules?: Rule[] | undefined;
  style?: CSSProperties;
  value?: string | number | undefined;
  type?: string;
  onBlur?: (e: FocusEvent) => void;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onFocus?: (e: FocusEvent) => void;
};

export const InputWithAddonAfter = ({
  addonAfter,
  dataTestId,
  disabled,
  initialValue,
  message,
  name,
  placeholder,
  rules = [],
  style,
  value,
  type,
  onBlur,
  onChange,
  onFocus,
}: InputWithAddonAfterProps) => {
  const [hasBeenFocused, setHasBeenFocused] = useState<boolean>(false);

  const handleBlur = (e: FocusEvent) => {
    setHasBeenFocused(false);
    onBlur?.(e);
  };
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange?.(e);
  };

  const handleFocus = (e: FocusEvent) => {
    setHasBeenFocused(true);
    onFocus?.(e);
  };

  return (
    <Form.Item
      className={`input-with-addon-after ${hasBeenFocused ? "active" : ""}`}
      name={name}
      rules={parseInputRules(rules, message)}
      initialValue={initialValue || undefined}
    >
      <AntInput
        addonAfter={addonAfter}
        data-testid={dataTestId}
        disabled={disabled}
        placeholder={placeholder}
        style={style}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        onFocus={handleFocus}
        type={type}
      />
    </Form.Item>
  );
};
